/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetVoicemailJudgmentResult200Response } from '../models';
/**
 * VoicemailJudgmentResultApi - axios parameter creator
 * @export
 */
export const VoicemailJudgmentResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 留守電判断結果取得API
         * @summary 留守電判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoicemailJudgmentResult: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('getVoicemailJudgmentResult', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription/voicemail_judgment_result`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoicemailJudgmentResultApi - functional programming interface
 * @export
 */
export const VoicemailJudgmentResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoicemailJudgmentResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 留守電判断結果取得API
         * @summary 留守電判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoicemailJudgmentResult(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetVoicemailJudgmentResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoicemailJudgmentResult(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VoicemailJudgmentResultApi - factory interface
 * @export
 */
export const VoicemailJudgmentResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoicemailJudgmentResultApiFp(configuration)
    return {
        /**
         * 留守電判断結果取得API
         * @summary 留守電判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoicemailJudgmentResult(callResultId: number, options?: any): AxiosPromise<GetVoicemailJudgmentResult200Response> {
            return localVarFp.getVoicemailJudgmentResult(callResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VoicemailJudgmentResultApi - interface
 * @export
 * @interface VoicemailJudgmentResultApi
 */
export interface VoicemailJudgmentResultApiInterface {
    /**
     * 留守電判断結果取得API
     * @summary 留守電判断結果取得API
     * @param {number} callResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailJudgmentResultApiInterface
     */
    getVoicemailJudgmentResult(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetVoicemailJudgmentResult200Response>;

}

/**
 * Request parameters for getVoicemailJudgmentResult operation in VoicemailJudgmentResultApi.
 * @export
 * @interface VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest
 */
export interface VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest {
    /**
     * 
     * @type {number}
     * @memberof VoicemailJudgmentResultApiGetVoicemailJudgmentResult
     */
    readonly callResultId: number
}

/**
 * VoicemailJudgmentResultApi - object-oriented interface
 * @export
 * @class VoicemailJudgmentResultApi
 * @extends {BaseAPI}
 */
export class VoicemailJudgmentResultApi extends BaseAPI implements VoicemailJudgmentResultApiInterface {
    /**
     * 留守電判断結果取得API
     * @summary 留守電判断結果取得API
     * @param {VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoicemailJudgmentResultApi
     */
    public getVoicemailJudgmentResult(requestParameters: VoicemailJudgmentResultApiGetVoicemailJudgmentResultRequest, options?: AxiosRequestConfig) {
        return VoicemailJudgmentResultApiFp(this.configuration).getVoicemailJudgmentResult(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
